import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeArticleDetailComponent } from '@features/knowledge/knowledge-article-detail/knowledge-article-detail.component';
import { NavigationComponent } from '@features/navigation/components/navigation/navigation.component';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Component({
    selector: 'app-knowledge-article-page',
    templateUrl: './knowledge-article-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavigationComponent, KnowledgeArticleDetailComponent],
})
export class KnowledgeArticlePageComponent implements OnInit {
    urlSlug: Observable<string>;
    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit(): void {
        this.urlSlug = this.activatedRoute.params.pipe(pluck('article'));
    }
}
